<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
      size="lg"
    >
      <slot name="body">
          
    <div>
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12" >
              <div v-if="isLastAction && !isHaveNote">
                <div v-if="isHaveCheck">

                  <b-form-group
                    v-slot="{ ariaDescribedby }"
                    label="اسم المنظمة الذي سيم اعتماده"
                    label-for="legalForm"
                  >
                    <validation-provider
                      mode="passive"
                      #default="{ errors }"
                      name="اسم المنظمة الذي سيم اعتماده"
                      rules="required"
                    >
                      <b-form-radio-group
                        variant="success"
                        v-model="form.accepted_ngo_name_for_establishing_ngo"
                        :options="names"
                        :aria-describedby="ariaDescribedby"
                        class="custom-control-success"
                        disabled-field="disabled"
                        id="legal-form-radio"
                        name="legal-form-radio"
                      />
    
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <form-input
                    v-model="form.decision_no_for_establishing_ngo"
                    rules="required"
                    label="رقم قرار الإشهار"
                  />
                  <form-mask
                    placeholder="YYYY-MM-DD"
                    options="date"
                    rules="required"
                    label="تاريخ قرار الإشهار"
                    v-model="form.decision_date_for_establishing_ngo"
                  />
                  <form-file-input
                    placeholder="اختر ملفاً"
                    id="document"
                    label="نسخة قرار الإشهار"
                    accept=".pdf"
                    v-model="form.decision_file_for_establishing_ngo"
                    rules="required"
                  />
                </div>

              </div>
              
              <form-textarea
                v-if="isHaveNote"
                class="my-1"
                label="السبب"
                rules="required"
                v-model="form.notes"
              />
            </b-col>
            <b-col  cols="12 " class="mt-2">
              <div class="d-flex justify-content-between">
                <p>
                  بيانات إضافية :
                </p>
                 <b-button
                  :variant="(isExtraDataShow || transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction') ? 'outline-danger' :'outline-success'"
                  @click="isExtraDataShow = !isExtraDataShow; form.extra_data = null"
                  size="sm"
                  :disabled="transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction'"
                >
                  <feather-icon :icon="(isExtraDataShow || transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction') ? 'XIcon' : 'PlusIcon'" />
                  <span v-if="isExtraDataShow || transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction'">
                    حذف
                  </span>
                    
                  <span v-else>
                    إضافة
                  </span>
                
                </b-button>

              </div>
             
              <hr />
            </b-col>
            <b-col cols="12">
              <form-textarea
                v-if="(isExtraDataShow || transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction')"
                class="my-1"
                v-model="form.extra_data"
                :rules="transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction' ? 'required' : ''"
              />
              
              <small
                v-if="transactionSlug === 'hold_general_body_meeting' && isLastAction && status == 'need_correction'"
                class="d-inline-block text-danger"
                style="white-space: pre-line"
                > يجب إدخال اسم أو أسماء المرشحين لعضوية مجلس الإدارة الواجب استبعادهم </small
              >
            </b-col>
            <b-col  cols="12 " class="mt-2">
              <div class="d-flex justify-content-between">
                <p>
                  المُرفقات :
                </p>
                 <b-button
                  variant="outline-success"
                  @click="onClickedAdd"
                  size="sm"
                >
                  <feather-icon icon="PlusIcon" />
                  إضافة
                
                </b-button>

              </div>
             
              <hr />
            </b-col>
            <b-col cols="12"  v-for="(file, fileId) in form.files" :key="fileId">
              <b-row>
                
                <b-col cols="5">
                  
                  <form-input
                    :placeholder= "`${fileId+1} - العنوان `"
                    v-model="file.title"
                    rules="required"
                    id="name"
                  />
                </b-col>
                <b-col cols="5">
                  <form-file-input
                    :placeholder="`${fileId+1} - الملف`"
                    id="document"
                    v-model="file.file"
                    rules="required"
                    accept=".doc,.pdf,.docx"
                  />
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-start">
                  <b-button
                    variant="outline-danger"
                    @click="onClickedDeleted(fileId)"
                    size="sm"
                  >
                    <feather-icon icon="XIcon" />
                    حذف
                  
                  </b-button>
                </b-col>
                <b-col cols="12" v-if="fileId !== form.files.length-1">
                  <hr />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormRadioGroup
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
// import store from "../pages/transactions/store";
const initForm = {files:[]};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea,
    BFormRadioGroup
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "إعتماد / إرسال",
    },
    isHaveNote: {
      type: Boolean,
      default: () => true,
    },
    isHaveCheck: {
      type: Boolean,
      default: () => false,
    },
    transactionSlug : String ,
    status : String ,
    isLastAction: {
      type: Boolean,
      default: () => false,
    },
    names: {
      type: Array,
      default: () => [],
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["TransactionType"]),
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactionType"]),
  },
  data() {
    return {
      form: {},
      required,
      integer,
      isExtraDataShow : false,
    };
  },
  
  mounted() {
    // this.fetchTransactionType()
    // this.$store.fetchTransactionType()
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          this.init(this.intializeForm);
        });
    },
    transactionSlug(newValue, oldValue) {  
        console.log('Transaction Slug changed from', oldValue, 'to', newValue);  
        // Place logic to handle the change  
    }, 
    
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    },
    
    onClickedAdd(){
      console.log(this.form)
      if(!this.form.hasOwnProperty('files') || Object.keys(this.form.files).length === 0 ){
    
        this.form.files =[{}]
      }
      else{
        
        // check if any form station => open without save Data
        let i=0
        if(this.form.files.length === 0)
        {
          this.form.files.push({})
        }
        
        else{
          for(let item of this.form.files)
          {
            i +=1
            if(Object.keys(item).length === 0)
            {
              this.form.files.splice(i-1, 1) 
            }
        
        
          }
          this.form.files.push({})
        }

      

      }
    },
    onClickedDeleted(i){
      this.form.files.splice(i-1, 1) 

    }
  },
};
</script>
